import { Injectable } from '@angular/core';
import { ApiConfigService } from '../../../shared-services/api-config.service';
import { Observable } from 'rxjs/Observable';
import { Meeting } from '../../../dtos/meeting';
import { FolderDto } from '../../../dtos/folderDto';

@Injectable({
  providedIn: 'root'
})
export class GuideService {

  constructor(private apiConfigService: ApiConfigService) { }

  getGuideFiles():Observable<FolderDto> {
    return this.apiConfigService.get<FolderDto>('api/guide/files');
  }

  createFolder(path: string, folderName: string):Observable<FolderDto> {
    return this.apiConfigService.post('api/guide/create', {path: path, folderName: folderName}) as unknown as Observable<FolderDto>;
  }

  uploadFiles(formData):Observable<any>{
    return this.apiConfigService.post("api/guide/upload", formData);
  }
}
